module.exports = __webpack_public_path__ + "img/inspiration.6492c1ba.png";